var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandoutHassleFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_84684",
    "data-name": "Group 84684",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112.75,
    height: 107,
    viewBox: "0 0 112.75 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24687",
    "data-name": "Rectangle 24687",
    width: 112.75,
    height: 107,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84683",
    "data-name": "Group 84683",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240190",
    "data-name": "Path 240190",
    d: "M56.584,107a18,18,0,1,0-18-18,18,18,0,0,0,18,18",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240191",
    "data-name": "Path 240191",
    d: "M45.241,22.565,29.914,79.492a5.013,5.013,0,0,0,4.5,6.293l24.2,2.023a7.238,7.238,0,0,0,7.641-5.416L81.178,24.5a5.844,5.844,0,0,0-5.664-7.3H52.253a7.259,7.259,0,0,0-7.012,5.371Z",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240192",
    "data-name": "Path 240192",
    d: "M29.891,82.031l26.542,2.09a4.652,4.652,0,0,0,5.683-3.315q.057-.216.093-.438L78.278,20.047c.562-2.113-1.393-2.832-2.832-2.832",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10876",
    "data-name": "Line 10876",
    x1: 5.888,
    transform: "translate(58.546 20.9)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240193",
    "data-name": "Path 240193",
    d: "M38.544,47.422A13.78,13.78,0,0,0,33.757,39.2a6.989,6.989,0,0,0-8-.584c-1.191,1.506,3.326,7.731,2.4,20.564-.674,9.6-2.54,14.361-.742,22.654,0,0,0,4.023-4.9,17.8",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240194",
    "data-name": "Path 240194",
    d: "M76.211,39.464a21.7,21.7,0,0,0,.472-6.473c0-4.045,3.146-7.327,4.5-3.326a25.438,25.438,0,0,1-.157,17.755Z",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240195",
    "data-name": "Path 240195",
    d: "M76.211,39.464a21.7,21.7,0,0,0,.472-6.473c0-4.045,3.146-7.327,4.5-3.326a25.438,25.438,0,0,1-.157,17.755Z",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240196",
    "data-name": "Path 240196",
    d: "M47.758,103.945s3.1-12.2,7.754-16.136",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240197",
    "data-name": "Path 240197",
    d: "M72.772,64.253a88.054,88.054,0,0,0,.45-16.2c-.247-1.91-4.742-5.169-5.529-9.507-.9-4.967,4.2-3.484,11.709,3.843,6.2,6.065,1.528,15.369-6.63,21.864",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240198",
    "data-name": "Path 240198",
    d: "M72.772,64.253a88.054,88.054,0,0,0,.45-16.2c-.247-1.91-4.742-5.169-5.529-9.507-.9-4.967,4.2-3.484,11.709,3.843C85.605,48.454,80.93,57.758,72.772,64.253Z",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240199",
    "data-name": "Path 240199",
    d: "M67.895,76.077A98.086,98.086,0,0,0,68.389,58.1c-.449-3.461-2.742-6.068-3.618-10.9-.989-5.529,2.674-6.742,12.226,5.394,5.978,7.549,0,16.247-9.1,23.483",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240200",
    "data-name": "Path 240200",
    d: "M67.895,76.077A98.086,98.086,0,0,0,68.389,58.1c-.449-3.461-2.742-6.068-3.618-10.9-.989-5.529,2.674-6.742,12.226,5.394C82.975,60.143,77,68.841,67.895,76.077Z",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240201",
    "data-name": "Path 240201",
    d: "M66.614,81.828a46.428,46.428,0,0,0,.97-13.17c-.45-3.461-2.247-8.608-2.967-12.743-.854-4.7,4.068-5.731,9.731,5.866,3.5,7.419-.07,13.889-7.734,20.047",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240202",
    "data-name": "Path 240202",
    d: "M66.614,81.828a46.428,46.428,0,0,0,.97-13.17c-.45-3.461-2.247-8.608-2.967-12.743-.854-4.7,4.068-5.731,9.731,5.866C77.851,69.2,74.278,75.67,66.614,81.828Z",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240203",
    "data-name": "Path 240203",
    d: "M51.061,36.656,44.836,50.635h6.225L46.634,64.682,62.1,46.815l-6.518-1.506,5.416-7.844Z",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240204",
    "data-name": "Path 240204",
    d: "M98.528,51.625,98.3,60.188l-5.911,1.551,1.843,8.046-10.851,3.64.877,8.36A19.262,19.262,0,0,1,92.6,91.112l19.185-26.857s-5.371-10.248-13.259-12.631Z",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240205",
    "data-name": "Path 240205",
    d: "M94.842,49.176l-.2,8.563-5.911,1.573,1.843,8.046L79.694,71l.876,8.36s9.844,5.663,12.024,11.754l19.19-26.858s-7.26-12.383-16.946-15.08Z",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10877",
    "data-name": "Line 10877",
    x1: 8,
    y2: 11.327,
    transform: "translate(90.662 65.715)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240206",
    "data-name": "Path 240206",
    d: "M24.857,30.026l-13.53.787-4.27,9.012L0,33.869,22.025,0,35.037,11.462,24.362,19.373Z",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10878",
    "data-name": "Line 10878",
    x1: 8.428,
    y2: 12.248,
    transform: "translate(15.373 12.678)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandoutHassleFree);
export default __webpack_public_path__ + "static/media/standoutHassleFree.d4cacc14d42804a8c3452a0c3878fada.svg";
export { ForwardRef as ReactComponent };